import React from 'react';
import { Section } from './ui/Section';
export function WhatYouGet() {
  const scrollToPricing = () => {
    const el = document.getElementById('pricing');
    if (el) {
      const top = el.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }
  };
  const items = ['6 tomos', 'Bonos prácticos', 'Sistema paso a paso', 'Acceso digital inmediato'];
  return <Section data-id="element-193" data-mp="1dsio0k9jqzx3">
      <h2 className="font-display text-2xl md:text-4xl font-bold text-center mb-10 text-brand-title" data-id="element-194" data-mp="1dsscg3ey0z0o">
        Todo el sistema. Listo para empezar.
      </h2>

      <div className="flex justify-center mb-8" data-id="element-195" data-mp="142z2t7yd2tz2">
        <img src="https://cdn.magicpatterns.com/uploads/1gwhDJbWYAzPqP47WvppdA/ChatGPT_Image_9_ago_2026__14_24_27-removebg-preview.png" alt="Sistema Mimetismo Nutricional™ — 6 Tomos + 6 Bonos Exclusivos" className="w-full max-w-sm md:max-w-md object-contain" loading="lazy" data-id="element-196" data-mp="1404gfavsez30" />
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 max-w-2xl mx-auto mb-10" data-id="element-197" data-mp="21iw73la5lofj">
        {items.map((item, i) => <div key={i} className="flex items-center gap-2 bg-white border border-brand-border rounded-xl px-3 py-3 justify-center" data-id="element-198" data-mp="2vdprd9htvgcg" data-mpi={i}>
            <span className="text-brand-primary font-bold shrink-0" data-id="element-199" data-mp="3565d8hw8wp2m">✓</span>
            <span className="font-body text-brand-text text-sm text-center" data-id="element-200" data-mp="30ex31jn3czoe">
              {item}
            </span>
          </div>)}
      </div>

      <div className="text-center" data-id="element-201" data-mp="3e5abro7t4ies">
        <button onClick={scrollToPricing} className="bg-brand-primary hover:bg-brand-primaryHover text-white font-heading font-bold text-lg py-4 px-10 rounded-xl transition-colors w-full md:w-auto shadow-card-lg mb-3" data-id="element-202" data-mp="3e8emz5joweey">
          Quiero acceder al sistema
        </button>
        <div className="text-brand-textMuted text-sm font-body" data-id="element-203" data-mp="3j6pvncy90ivl">
          Acceso inmediato · Material 100% digital
        </div>
      </div>
    </Section>;
}